import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useMaintainStore = defineStore('maintain', () => {
  const id = ref<string>('0')
  const level = ref<string>('')
  const isShowMaintainDialog = ref(false)

  const showMaintainDialog = (
    targetId: number | string,
    targetLevel: string
  ): void => {
    id.value = targetId?.toString()
    level.value = targetLevel
    isShowMaintainDialog.value = true
  }

  return {
    id,
    level,
    isShowMaintainDialog,
    showMaintainDialog
  }
})
